// The English prompt fragments injected by renderSonicTraits() — verbatim from
// spec §3.1-§3.5. Typed as exhaustive Records so a missing vocabulary term is a
// compile error.
const GENRE_SNIPPETS = {
    rock: "rock instrumentation",
    metal: "heavy distorted metal guitars",
    pop: "polished radio-friendly pop production",
    electronic: "electronic synthesized production",
    hiphop: "hip-hop beat and groove",
    jazz: "jazz harmony and improvisation",
    funk: "tight funk groove",
    folk: "acoustic folk instrumentation",
    classical: "orchestral classical arrangement",
    rnb: "smooth R&B feel",
    reggae: "reggae offbeat rhythm",
    ambient: "ambient atmospheric texture",
};
const ERA_SNIPPETS = {
    "60s": "1960s production aesthetic",
    "70s": "1970s analog production",
    "80s": "1980s synth-driven production",
    "90s": "1990s production style",
    "2000s": "2000s digital production",
    modern: "contemporary production",
};
const TIMBRE_SNIPPETS = {
    warm: "warm rounded tone",
    bright: "bright crisp tone",
    dark: "dark moody tone",
    gritty: "gritty raw texture",
    clean: "clean polished tone",
    lofi: "lo-fi tape-saturated texture",
    lush: "lush layered texture",
    minimal: "sparse minimal arrangement",
};
const VIBE_SNIPPETS = {
    melancholic: "melancholic mood",
    uplifting: "uplifting mood",
    aggressive: "aggressive attitude",
    dreamy: "dreamy atmosphere",
    playful: "playful character",
    epic: "epic cinematic scale",
    nostalgic: "nostalgic feel",
    groovy: "groovy danceable feel",
};
// Per-axis term -> text maps for the list/single axes.
export const SONIC_TRAIT_SNIPPETS = {
    genres: GENRE_SNIPPETS,
    era: ERA_SNIPPETS,
    timbre: TIMBRE_SNIPPETS,
    vibe: VIBE_SNIPPETS,
};
// `energy` has no terms — its snippet is chosen by the 1..5 scalar value.
// `3` is the neutral point and injects nothing (spec §3.3).
export const SONIC_ENERGY_SNIPPETS = {
    1: "very calm and subdued",
    2: "relaxed and laid-back",
    3: "",
    4: "energetic and driving",
    5: "intense and high-energy",
};
//# sourceMappingURL=snippets.js.map